import { render } from "./BarrierFreeMap.vue?vue&type=template&id=7202da46&scoped=true"
import script from "./BarrierFreeMap.vue?vue&type=script&lang=typescript"
export * from "./BarrierFreeMap.vue?vue&type=script&lang=typescript"

import "./BarrierFreeMap.vue?vue&type=style&index=0&id=7202da46&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7202da46"

export default script